export default __webpack_public_path__ + "static/media/1.8d6d2ff8.jpg";